import { render, staticRenderFns } from "./Local.vue?vue&type=template&id=6403cd82"
import script from "./Local.vue?vue&type=script&lang=js"
export * from "./Local.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports